import React from "react";
import QuoteStepBase from '../../components/QuoteStepBase'
import ButtonContinue from "../../components/ButtonContinue";
import { IQuoteStepState, IDriverStepProps } from "../../components/interfaces";
import { IAppState } from "../../state/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS, COMPONENTS } from "../../AppConstants";
import Utilities from "../../classes/Utilities";
import { ListGroup } from 'react-bootstrap'
import { IListOption, IAdditionalDriver, IDriverBase, IQuoteApiClient, ILOBApiClient, IPaths } from "../../classes/Domain";
import { IBindQuoteResponse } from "../../state/fullQuoteActions";
import { IBindQuoteResult, IUpdateAdditionalDriverResult } from "../../classes/ExternalQuote";
import _ from "lodash";
import { Alert } from 'react-bootstrap';
import { validationUtils } from "../../validation/Validation";
import { ValidatableForm } from "../../components/ValidatableForm";
import AdditionalDriver from "../../components/AdditionalDriver";
import QuoteActions from "../../state/appActions";
import FullQuoteActions from "../../state/fullQuoteActions";


const driverOptions = [
    { value: "", label: "Please select" },
    { value: "ADD", label: "Add Driver" },
    { value: "EXCLUDE", label: "Exclude Driver" },
    { value: "DISREGARD", label: "Disregard" },
    { value: "REPRESENTED", label: "Already Represented" },
];

interface IState extends IQuoteStepState {
    driverSelections: any,
    additionalDrivers: Array<IAdditionalDriver>,
    bindQuoteResult: IBindQuoteResult | null,
    updateResult: IUpdateAdditionalDriverResult | null,
}

interface IProps extends IDriverStepProps {
    quoteId: number,
    paymentPlanCode: number,
    hasViolationData: boolean,
    quoteDrivers: Array<IDriverBase>,
    additionalDrivers: Array<IAdditionalDriver>,
    hasAdditionalDrivers: boolean,
    bindQuote: (quoteId: number) => Promise<any>,
    updateAppStateViolations: (quoteId: number) => Promise<any>,
    updateAppStateAdditionalDrivers: (quoteId: number, additionalDrivers: Array<IAdditionalDriver>) => Promise<any>,
    reRateQuote: (quoteId: number, paymentPlanCode: number, hasMvrViolations: boolean, hasAdditionalDrivers: boolean) => Promise<any>,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths;
}

class AdditionalDrivers extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.getDriverSelection = this.getDriverSelection.bind(this);
        this.onDriverReasonChange = this.onDriverReasonChange.bind(this);
        this.onDriverStatusChange = this.onDriverStatusChange.bind(this);
        this.onDriverDataChange = this.onDriverDataChange.bind(this);

        this.state = {
            driverSelections: {},
            additionalDrivers: [],
            updatingStore: false,
            bindQuoteResult: null,
            updateResult: null,
            errors: null
        }
    }

    componentDidMount() {
        this.props.reportCurrentStep();

        this.setState({ ...this.state, updatingStore: false, errors: null });

        validationUtils.subscribeToValidationFailure(FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure(FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const additionalDrivers = nextProps.additionalDrivers;
            nextProps.meta.propsSource = "";

            if (null === additionalDrivers) return prevState;

            return {
                ...prevState,
                additionalDrivers: additionalDrivers,
                driverSelections: {}
            };
        }

        return prevState;
    }

    next() {
        this.setState({ updatingStore: true }, () => {
            this.props.updateAppStateAdditionalDrivers(this.props.quoteId, this.state.additionalDrivers)
                .then((response) => {
                    this.setState({ updateResult: response.data }, () => {
                        if (!this.state.updateResult?.hasErrors) {
                            this.setState({ ...this.state, errors: null }, () => {
                                if (this.state.updateResult?.driversWasChanged) {
                                    this.props.updateAppStateViolations(this.props.quoteId)
                                        .then((violationsResponse) => {
                                            if (violationsResponse.data.needProcessingAdditionalDrivers) {
                                                this.stopUpdate();
                                                this.props.history.replace(this.props.PATHS.FQ_ADDITIONAL_DRIVERS);
                                            }
                                            else if (violationsResponse.data.hasViolationData) {
                                                this.props.history.push(Utilities.formatUrl(this.props.PATHS.FQ_VIOLATIONS, ""));
                                            }
                                            else {
                                                this.props.reRateQuote(this.props.quoteId, this.props.paymentPlanCode, false, this.props.hasAdditionalDrivers)
                                                    .then(() => {
                                                        this.props.history.push(this.props.PATHS.FQ_POLICY_DETAILS);
                                                    }, () => this.stopUpdate());
                                            }
                                        }, () => this.stopUpdate());
                                }
                                else {
                                    if (this.props.hasViolationData) {
                                        this.props.history.push(Utilities.formatUrl(this.props.PATHS.FQ_VIOLATIONS, ""));
                                    }
                                    else {
                                        this.props.bindQuote(this.props.quoteId)
                                            .then((bindResponse: IBindQuoteResponse) => {
                                                this.setState({ bindQuoteResult: bindResponse.data.bindQuoteResult }, () => {
                                                    if (null !== this.state.bindQuoteResult && this.state.bindQuoteResult.errors && 0 < this.state.bindQuoteResult.errors.length) {
                                                        this.stopUpdate();
                                                        return;
                                                    }
                                                    this.props.history.push(this.props.PATHS.FQ_FINISH);
                                                });
                                            },
                                                () => this.stopUpdate()
                                            );
                                    }
                                }
                            });
                        }
                        else {
                            this.stopUpdate();
                        }
                    });
                }, () => this.stopUpdate());
        });
    }

    stopUpdate() {
        this.setState({ ...this.state, updatingStore: false });
    }

    getDriverSelection(driverIndex: number, status: string = "") {
        const selection = this.state.driverSelections?.hasOwnProperty(driverIndex)
            ? this.state.driverSelections[driverIndex]
            : status === ""
                ? null
                : status;

        if (null === selection) return driverOptions[0];

        for (var i = 1; i < driverOptions.length; i++) {
            if (selection === driverOptions[i].value) return driverOptions[i];
        }

        return null;
    }

    onDriverReasonChange(value: any, adDriver: IAdditionalDriver, driverIndex: number, property: string)
    {
        var additionalDrivers = [...this.state.additionalDrivers];

        var additionalDriver = additionalDrivers[driverIndex];

        if (additionalDriver && additionalDriver.driver.id == adDriver.driver.id)
        {
            if (property === "representedDriverId")
            {
                let representedDriver = this.props.quoteDrivers.find(_item => _item.id === Number(value));

                if (representedDriver) {
                    additionalDriver[property] = representedDriver.id;
                }
                else {
                    additionalDriver[property] = -1;
                }
            }
            else
            {
                additionalDriver[property] = value;
            }
        }

        this.setState({ ...this.state, additionalDrivers });
    }

    onDriverStatusChange(driver: IDriverBase, driverIndex: number, option: IListOption | null)
    {
        if (!option || option.value === "") return;

        var additionalDrivers = [...this.state.additionalDrivers];
        var driverSelections = { ...this.state.driverSelections };

        driverSelections[driverIndex] = option.value;

        var additionalDriverState = { driver: driver, status: option.value };

        this.upsert(additionalDrivers, additionalDriverState);

        this.setState({ ...this.state, additionalDrivers, driverSelections, errors: null, updateResult: { ...this.state.updateResult, hasErrors: false, errors: null } });
    }

    onDriverDataChange(value: any, driver: IDriverBase, driverIndex: number, property: string)
    {
        var additionalDrivers = [...this.state.additionalDrivers];

        var additionalDriver = additionalDrivers[driverIndex];

        if (additionalDriver && additionalDriver.driver.id == driver.id) {
            additionalDriver.driver[property] = value;
        }

        this.setState({ ...this.state, additionalDrivers });
    }

    upsert(array: Array<IAdditionalDriver>, item: IAdditionalDriver)
    {
        const i = array.findIndex(_item => _item.driver.id === item.driver.id);

        if (i > -1) {
            array[i] = item;
        }
        else {
            array.push(item);
        }
    }

    showErrors(errors: Array<string> | undefined) {
        if (!errors || 0 === errors.length) return null;
        return <Alert variant={"danger"}>
            <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
            <p>Please review errors below</p>
            <ul>
                {
                    errors.map((error) => (
                        <li key={Utilities.uniqueId()}>
                            <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: error }}></p>
                        </li>
                    ))
                }
            </ul>
        </Alert>;
    }

    render() {
        return (
            <QuoteStep id="additionalDrivers" className="">
                    <div className="titleArea">
                        <h5>Additional Drivers</h5>
                    </div>

                    { this.showErrors(this.state.bindQuoteResult?.errors)}

                    {
                        this.state.updateResult && this.state.updateResult.errors?.length > 0
                            ? <Alert variant={"danger"}>
                                <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                                <p>Please review errors below</p>
                                <ul>
                                    {
                                        this.state.updateResult.errors.map((error) => (
                                            <li key={Utilities.uniqueId()}>
                                                <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: error }}></p>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </Alert>
                            : null
                    }

                <div className="rate-result">
                    {this.state.additionalDrivers && this.state.additionalDrivers.length > 0
                            ?
                        <ValidatableForm hasErrors={null != this.state.errors}>
                            <ListGroup variant="flush">
                            {
                                    this.state.additionalDrivers.map((driverData, driverIndex) => (
                                        <AdditionalDriver
                                            key={"additionalDriver_" + driverData.driver.id}
                                            disabled={this.state.updatingStore}
                                            quoteDrivers={this.props.quoteDrivers}
                                            driverOptions={driverOptions}
                                            driverIndex={driverIndex}
                                            additionalDriver={driverData}
                                            getDriverSelection={this.getDriverSelection}
                                            onDriverStatusChange={this.onDriverStatusChange}
                                            onDriverDataChange={this.onDriverDataChange}
                                            onDriverReasonChange={this.onDriverReasonChange}
                                        />
                                    ))
                                }
                            </ListGroup>
                        </ValidatableForm>
                            :
                            <div>
                                <Alert variant={"warning"}>
                                <h5 className="text-center">Already Processed</h5>
                                </Alert>
                            </div>
                        }
                    </div>

                    <div className="btnContainer">
                        <ButtonContinue
                            label="Continue"
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IProps) => {
    return {
        quoteId: state.externalQuote?.rtrQuoteId,
        paymentPlanCode: state.externalQuote?.paymentPlanCode,
        hasViolationData: state.externalQuote?.mvrResult?.hasViolationData,
        additionalDrivers: state.externalQuote?.mvrResult?.additionalDrivers,
        hasAdditionalDrivers: state.externalQuote?.hasAdditionalDrivers,
        quoteDrivers: state.externalQuote?.drivers,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS)),
        bindQuote: (quoteId: number) => dispatch(fullQuoteActions.bindQuote(quoteId)),
        updateAppStateViolations: (quoteId: number) => dispatch(fullQuoteActions.getViolations(quoteId)),
        updateAppStateAdditionalDrivers: (quoteId: number, additionalDrivers: Array<IAdditionalDriver>) => dispatch(fullQuoteActions.updateAdditionalDrivers(quoteId, additionalDrivers)),
        reRateQuote: (quoteId: number, paymentPlanCode: number, hasMvrViolations: boolean, hasAdditionalDrivers: boolean) => dispatch(fullQuoteActions.reRateQuote(quoteId, paymentPlanCode, hasMvrViolations, hasAdditionalDrivers))
    };
};

export default connect(mapProps, mapDispatch)(AdditionalDrivers);
